import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { TextField } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import type { FC } from 'react';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';

interface RhfPasswordFieldProps {
  label: string;
  name: string;
}

const RhfPasswordField: FC<RhfPasswordFieldProps & Record<string, any>> = ({
  label,
  name,
  ...rest
}: RhfPasswordFieldProps) => {
  const [showPassword, setShowPassword] = useState(false);

  const {
    register,
    formState: { errors }
  } = useFormContext();

  return (
    <TextField
      error={!!errors[name]}
      type={showPassword ? 'text' : 'password'}
      fullWidth
      helperText={errors[name] ? errors[name]?.message : ''}
      label={label}
      variant="outlined"
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={() => setShowPassword((show) => !show)}
              aria-label={showPassword ? 'Hide password' : 'Show password'}
            >
              {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
            </IconButton>
          </InputAdornment>
        )
      }}
      {...register(name)}
      {...rest}
    />
  );
};

export default RhfPasswordField;
